import { foodImage, logo } from "@/assets";

const templete1 = ({ template, previewData }) => {
  const isStrictPreview = Boolean(previewData?.strictTablePreview);
  const backgroundImage = template?.image_url || foodImage;
  const logoImage = template?.logo_url || logo;
  const templateTitle = previewData?.title || (isStrictPreview ? "N/A" : "BIRTHDAY GIFT CARD");
  const customerName = previewData?.customerName || (isStrictPreview ? "Not provided" : "Md Rasel Mahmud");
  const cardCode = previewData?.code || (isStrictPreview ? "N/A" : "#32154232");
  const hasReward = previewData?.reward !== null && previewData?.reward !== undefined && previewData?.reward !== "";
  const reward = hasReward ? previewData?.reward : isStrictPreview ? "N/A" : 100;
  const rewardType = previewData?.rewardType || (isStrictPreview ? "" : "fixed");
  const quote = previewData?.message
    ? `\"${previewData.message}\"`
    : isStrictPreview
      ? "Not provided"
      : "\"Happy Birthday\"";
  const paymentText = previewData?.paymentMethods?.length
    ? previewData.paymentMethods.map(m => m.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(", ")
    : isStrictPreview
      ? "Not provided"
      : "Cash Only";
  const orderTypeText = previewData?.orderTypes?.length
    ? `For ${previewData.orderTypes.map(t => t.toLowerCase().replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())).join(" / ")} only`
    : isStrictPreview
      ? "Not provided"
      : "For dine in only ( not for Takeaway or Delivery )";
  const isConjunction =
    previewData?.isConjunction !== null && previewData?.isConjunction !== undefined
      ? Boolean(previewData?.isConjunction)
      : previewData?.is_conjunction !== null && previewData?.is_conjunction !== undefined
        ? Boolean(previewData?.is_conjunction)
        : !isStrictPreview;
  const conjunctionText = isConjunction ? "Not conjunction with any other offer" : null;
  const expiryText = previewData?.expiryDate || (isStrictPreview ? "N/A" : "12/05/2026");

  return (
    <div className="flex items-center justify-center p-4">
      <div
        data-export-capture="gift-card-template"
        className="relative w-full max-w-2xl h-[300px] shadow-2xl overflow-hidden rounded-sm flex"
      >
        <div
          className="absolute inset-0 w-full h-full bg-cover bg-center"
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        ></div>

        <div
          className="absolute inset-0 bg-[#2D0E0A]/90"
          style={{ clipPath: "polygon(0 0, 75% 0, 85% 100%, 0% 100%)" }}
        ></div>

        <div className="relative z-10 w-full flex justify-between p-8 text-white">
          <div className="flex flex-col justify-center">
            <div>
              <img src={logoImage} alt="Logo" className="w-24 mb-2" />
            </div>
            <h1 className="text-2xl font-bold tracking-wider mb-1 uppercase">
              {templateTitle}
            </h1>
            <p className="text-base font-medium opacity-90">{customerName}</p>
            <p className="text-base opacity-90 mb-6">Code {cardCode}</p>

            {quote && quote !== "Not provided" && quote !== "No provide" && quote !== "\"Not provided\"" && quote !== "\"No provide\"" && (
              <p className="italic text-gray-300 mb-6">{quote}</p>
            )}

            {/* Terms and Conditions */}
            {((paymentText && paymentText !== "Not provided" && paymentText !== "No provide") ||
              (orderTypeText && orderTypeText !== "Not provided" && orderTypeText !== "No provide") ||
              conjunctionText ||
              (expiryText && expiryText !== "N/A" && expiryText !== "Not provided" && expiryText !== "No provide")) && (
              <div className="text-[11px] leading-tight opacity-90 tracking-wide">
                <p className="mb-1">-Terms & Conditions-</p>
                <ul className="list-disc list-inside space-y-0.5">
                  {paymentText && paymentText !== "Not provided" && paymentText !== "No provide" && <li>{paymentText}</li>}
                  {orderTypeText && orderTypeText !== "Not provided" && orderTypeText !== "No provide" && <li>{orderTypeText}</li>}
                  {conjunctionText && <li>{conjunctionText}</li>}
                  {expiryText && expiryText !== "N/A" && expiryText !== "Not provided" && expiryText !== "No provide" && <li>Exp. Date : {expiryText}</li>}
                </ul>
              </div>
            )}
          </div>

          {/* Right Side: Price */}
          <div className="absolute top-4 right-20 sm:right-32 md:right-44 text-cyellow flex items-start">
            <span className="text-xs mt-1 font-bold mr-1">{rewardType === "percentage" || rewardType === "%" ? "" : "£"}</span>
            <span className="text-3xl font-bold">
              {reward}
              {rewardType === "percentage" || rewardType === "%" ? "%" : ""}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default templete1;
